module.exports = __webpack_public_path__ + "static/media/loading.b7480677.gif";